import { User } from 'oidc-client-ts';
import { Action } from '../actions';
import {
  DISMISS_IMPERSONATION_BLOCKED,
  LOAD_USER_ERROR,
  OIDC_ACCESS_TOKEN_EXPIRED,
  OIDC_ACCESS_TOKEN_EXPIRING,
  OIDC_SILENT_RENEW_ERROR,
  OIDC_USER_LOADED,
  OIDC_USER_SIGNED_OUT,
  SHOW_IMPERSONATION_BLOCKED
} from '../actions/actionTypes';
import { getClaims, LoginDetails } from '../models/loginDetails';
import { initialAppState } from '../models/state/appState';
import { AspNetRole, hasAspNetRole } from '../models/state/enumerations/Role';

const loggedOutState: LoginDetails = {
  isSignedIn: false,
  impersonationBlocked: false
};

const createStateFromUser = (user?: User): LoginDetails => {
  const profile = user && getClaims(user);
  let isCellhireUser: boolean = false;
  let isCellhireSuperUser: boolean = false;
  if (profile && profile.role) {
    if (typeof profile.role === 'string') {
      profile.role = [profile.role];
    }

    isCellhireSuperUser = hasAspNetRole(user, AspNetRole.CellhireSuperUser);
    isCellhireUser = isCellhireSuperUser || hasAspNetRole(user, AspNetRole.Cellhire);
  }

  return user
    ? {
        isSignedIn: true,
        impersonationBlocked: false,
        user: {
          name: getClaims(user).name ?? '',
          email: '',
          isCellhireSuperUser,
          isCellhireUser,
          user,
          subportalUser: getClaims(user).subportal_user === true,
          impersonatorId: getClaims(user).ImpersonatorId
        }
      }
    : loggedOutState;
};

export default function loginReducer(
  state: LoginDetails = initialAppState.loginDetails,
  action: Action<any>
): LoginDetails {
  switch (action.type) {
    case OIDC_USER_LOADED: {
      const typedAction = action as Action<User>;
      const user = typedAction.payload;
      return Object.assign({}, state, createStateFromUser(user));
    }
    case OIDC_SILENT_RENEW_ERROR: // may want to do something better for this one
    case LOAD_USER_ERROR: // ditto
    case OIDC_ACCESS_TOKEN_EXPIRED:
      //// OIDC_USER_UNLOADED is deliberately excluded.
      //// On signing out the user is first unloaded, then subsequently logged out.
      //// If we set them to logged out, the application automatically logs them in again,
      //// and the user is never logged out.
      //// It seems better to ignore the user being unloaded.
      return Object.assign({}, state, loggedOutState);
    case OIDC_USER_SIGNED_OUT:
      return Object.assign({}, state, loggedOutState, { user: undefined });
    case SHOW_IMPERSONATION_BLOCKED:
      return Object.assign({}, state, { impersonationBlocked: true });
    case DISMISS_IMPERSONATION_BLOCKED:
      return Object.assign({}, state, { impersonationBlocked: false });
    case OIDC_ACCESS_TOKEN_EXPIRING:
    default:
      return state;
  }
}
